const TRANSCRIPT_FIELDS = [
  "cleaned_text",
  "processed_text",
  "text",
  "transcript",
  "interview_transcript",
];

const MIN_TRANSCRIPT_LENGTH = 500;

const getTextValue = (value) => {
  if (typeof value === "string") return value;
  if (typeof value?.summary === "string") return value.summary;
  return "";
};

const cleanPrefix = (value) => value
  .replace(/(?:\s|<br\s*\/?\s*>|<p>\s*<\/p>)+$/gi, "")
  .trim();

/**
 * Return the display-safe short summary for a document.
 *
 * Some grouped processing runs stored `summary + cleaned transcript` in
 * short_summary. Existing records cannot be regenerated on page load, so strip
 * a transcript only when a complete, sufficiently long source field is embedded
 * verbatim. This keeps ordinary summaries and short source documents untouched.
 */
export const getShortSummaryDisplayContent = (documentData) => {
  const summary = getTextValue(documentData?.short_summary).trim();
  if (!summary) return null;

  let firstTranscriptIndex = -1;

  TRANSCRIPT_FIELDS.forEach((fieldName) => {
    const transcript = getTextValue(documentData?.[fieldName]).trim();
    if (transcript.length < MIN_TRANSCRIPT_LENGTH) return;

    const index = summary.indexOf(transcript);
    if (index !== -1 && (firstTranscriptIndex === -1 || index < firstTranscriptIndex)) {
      firstTranscriptIndex = index;
    }
  });

  if (firstTranscriptIndex === -1) return summary;

  const prefix = cleanPrefix(summary.slice(0, firstTranscriptIndex));
  return prefix || null;
};
